const state = {
  showLogin: false,
  userInfo: localStorage.getItem('JHUserInfo')
    ? JSON.parse(JSON.parse(localStorage.getItem('JHUserInfo')).data)
    : {},
}

const getters = {
  showLogin: (state) => state.showLogin,
  userInfo: (state) => state.userInfo,
}

const mutations = {
  SET_showLogin: (state, { status = false }) => {
    state.showLogin = status
  },
  setUserInfo: (state, userInfo) => {
    state.userInfo = userInfo
  },
}

const actions = {
  emitShowLogin(context, { status = false }) {
    context.commit('SET_showLogin', { status })
  },
  emitSetUserInfo(context, userInfo) {
    if (userInfo) {
      const {
        loginPhone = '',
        isGd = '',
        openDate = '',
        sessionId = '',
        phoneInfo: {
          accessNumber = '',
          mgmtProv = '',
          mgmtProvName = '',
          mgmtDistrict = '',
          areaCode = '',
          mgmtDistrictName = '',
        },
      } = userInfo
      const userMessage = {
        accessNum: loginPhone || accessNumber,
        areaInfo: `${mgmtProv}_${mgmtDistrict}`,
        areaName: mgmtProvName,
        cityId: areaCode,
        cityName: mgmtDistrictName,
        isGd,
        openDate,
        provinceId: mgmtProv,
        sessionId,
      }
      localStorage.setItem(
        'JHUserInfo',
        JSON.stringify({
          data: JSON.stringify(userMessage),
        })
      )
      context.commit('setUserInfo', userMessage)
    } else {
      localStorage.setItem('JHUserInfo', '')
      context.commit('setUserInfo', userInfo)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
